export default __webpack_public_path__ + "static/media/arrowRight.6de46748.svg";